// extracted by mini-css-extract-plugin
module.exports = {"cross":"Close_cross__MvhtB","cross-xs":"Close_cross-xs__UGMic","cross-sm":"Close_cross-sm__Nh3W4","cross-md":"Close_cross-md__Swmzk","cross-lg":"Close_cross-lg__RILq2"};